import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Notification } from '../model/notification';
import { BehaviorSubject, catchError, interval, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private readonly notificationsSubject = new BehaviorSubject<Notification[]>([]);
  public notifications$ = this.notificationsSubject.asObservable();

  constructor(private readonly http: HttpClient) {}

  getAllNotifications() {
    return this.http.get(environment.api_url + 'notifications');
  }

  getActiveNotifications() {
    return this.http
      .get<Notification[]>(environment.api_url + 'notifications/user')
      .pipe(
        tap((notifications) => this.notificationsSubject.next(notifications)),
        catchError((error) => {
          console.error(
            'Erreur lors du chargement des notifications actives:',
            error,
          );
          throw error;
        }),
      );
  }

  createNotification(notification: Notification) {
    return this.http.post(environment.api_url + 'notifications', notification);
  }

  createUserNotification(notification: Notification) {
    return this.http.post(
      environment.api_url + 'notifications/user',
      notification,
    );
  }

  createShopNotification(notification: Notification, shopCode: string) {
    return this.http.post(
      environment.api_url + 'notifications/shop',
      notification,
      {
        params: { shopCode: shopCode },
      },
    );
  }

   createAggregatorNotification(notification: Notification, aggregatorCode: string) {
    return this.http.post(
      environment.api_url + 'notifications/aggregator',
      notification,
      {
        params: { aggregatorCode: aggregatorCode },
      },
    );
  }

  updateNotification(notification: Notification) {
    return this.http.post(
      environment.api_url + 'notifications/update',
      notification,
    );
  }

  deleteNotification(notificationCode: string) {
    return this.http.delete(environment.api_url + 'notifications', {
      params: { notificationCode: notificationCode },
    });
  }

   deleteUserNotification(notificationCode: string) {
    return this.http.delete(environment.api_url + 'notifications/user', {
      params: { notificationCode: notificationCode },
    }).pipe(
      tap(() => {
        const current = this.notificationsSubject.value;
        const filtered = current.filter(n => n.notificationCode !== notificationCode);
        this.notificationsSubject.next(filtered);
      })
    );;
  }

  refreshNotifications() {
    this.getActiveNotifications().subscribe();
  }

  // Méthode pour démarrer le polling automatique
  startPolling(intervalMs: number = 30000) {
    // Charger immédiatement
    this.refreshNotifications();

    // Puis toutes les X secondes
    return interval(intervalMs).subscribe(() => {
      this.refreshNotifications();
    });
  }
}
